export enum CATEGORY_CODE {
  CATEGORY_1_1 = "Category 1.1",
  CATEGORY_1_2 = "Category 1.2",
  CATEGORY_2_1 = "Category 2.1",
  CATEGORY_3_1 = "Category 3.1",
  CATEGORY_3_2 = "Category 3.2",
  CATEGORY_3_3 = "Category 3.3",
  CATEGORY_4_1 = "Category 4.1",
  CATEGORY_3_4 = "Category 3.4",
  CATEGORY_3_5 = "Category 3.5",
}

export enum EMISSION_METHOD_NAME {
  DISTANCE_TRAVELLED_BY_VEHICLE_TYPE = "Distance Travelled by Vehicle Type",
  DISTANCE_AND_FUEL_CONSUMPTION_BY_VEHICLE_TYPE = "Distance & Fuel Consumption by Vehicle Type",
  DISTANCE_TRAVELLED_BY_LOGISTICS_TYPE = "Distance Travelled by Logistics Type",
  CRADLE_TO_PRODUCTION = "Cradle to Production",
}

export enum EMISSION_TYPE {
  TYPE_63 = 63,
}

export enum EMISSION_SUB_TYPE {
  TYPE_239 = 239,
}

export enum UOM {
  UOM_65 = 65,
  UOM_43 = 43,
}

export enum CURRENCY {
  CURRENCY_48 = 48,
  CURRENCY_49 = 49,
}

export enum MODULE_GROUP {
  GROUP_2 = 2,
  GROUP_15 = 15,
  GROUP_19 = 19,
}

export enum STEPS {
  DETAILS = "DETAILS",
  TRANSACTIONS = "TRANSACTIONS",
  BASIC_INFO = "BASIC INFO",
  ADD_UNIT = "ADD_UNIT",
  ADD_PREFERENCE = "ADD_PREFERENCE",
  EMISSION_SUMMARY = "EMISSION SUMMARY",
  SELECT_SCOPE = "SELECT SCOPE",
  ACTIVITY_DATA = "ACTIVITY DATA",
  EMISSION_DETAILED_VIEW = "EMISSION DETAILED VIEW",
  EMISSION_TARGET = "EMISSION TARGET",
  METRICS = "METRICS",
  PREFERENCES = "PREFERENCES",
  ALL = "ALL",
  CATEGORYWISE = "CATEGORYWISE",
  ASSETS = "ASSETS",
  EMISSION_AUDIT_SUMMARY = "EMISSION AUDIT SUMMARY",
  UPLOAD_CERTIFICATE = "UPLOAD CERTIFICATE",
}

export enum TARGET_REDUCER_TYPES {
  ADD_TARGET = "ADD_TARGET",
  ADD_BASELINE = "ADD_BASELINE",
  UPDATE_TARGET = "UPDATE_TARGET",
  UPDATE_TARGET_METRIC = "UPDATE_TARGET_METRIC",
  REMOVE_TARGET = "REMOVE_TARGET",
  SELECT_FACILITY = "SELECT_FACILITY",
  CARBON_PRICE = "CARBON_PRICE",
  SET_CARBON_CURRENCY = "SET_CARBON_CURRENCY",
  ADD_METRICS = "ADD_METRICS",
  REMOVE_METRICS = "REMOVE_METRICS",
  ADD_EMISSIONS = "ADD_EMISSIONS",
  RESET_STATE = "RESET_STATE",
  UPDATE_METRIC_UOMS = "UPDATE_METRIC_UOMS",
}

export enum ASSET_REDUCER {
  SET_INPUT_FIELD = "SET_INPUT_FIELD",
  SET_SELECTED_DROPDOWN = "SET_SELECTED_DROPDOWN",
  SET_INITIAL_STATE = "SET_INITIAL_STATE",
}

export enum ORG_REDUCER {
  SET_CATEGORY_PREFERENCES = "SET_CATEGORY_PREFERENCES",
  SET_COMPANY_PREFERENCES = "SET_COMPANY_PREFERENCES",
}

export enum USER_REDUCER {
  SET_USER_DETAILS = "SET_USER_DETAILS",
}

export enum AUTH_REDUCER {
  SET_TOAST = "SET_TOAST",
  START_LOGIN = "START_LOGIN",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  SET_USERNAME = "SET_USERNAME",
  SET_USER = "SET_USER",
  SET_CURRENT_BUNIT = "SET_CURRENT_BUNIT",
  SET_BUNITS = "SET_BUNITS",
  SET_TOKEN = "SET_TOKEN",
  AUTH_ERROR = "AUTH_ERROR",
  SET_USER_DATA = "SET_USER_DATA",
  SET_CUSTOMER_LOGO = "SET_CUSTOMER_LOGO",
  SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS",
}

export enum SUBSCRIPTION_REDUCER {
  SET_SUBSCRIPTION_PERMISSIONS = "SET_SUBSCRIPTION_PERMISSIONS",
  SET_ADDON_PERMISSIONS = "SET_ADDON_PERMISSIONS",
  SET_CURRENT_TERM_ENDS_AT = "SET_CURRENT_TERM_ENDS_AT",
  SET_CARD_DETAILS_STATUS = "SET_CARD_DETAILS_STATUS",
  SET_FROM_ZOHO_PAYMENTS_PAGE = "SET_FROM_ZOHO_PAYMENTS_PAGE",
  SET_CURRENT_PLAN = "SET_CURRENT_PLAN",
  SET_SUBSCRIPTION_RES = "SET_SUBSCRIPTION_RES",
}

export enum TARGET_TYPES {
  BASELINE = "BASELINE",
  TARGET = "TARGET",
  NET_ZERO = "NET ZERO",
  MOST_RECENT = "MOST RECENT",
}

export enum METRIC_TYPES {
  ACTIVE_EMPLOYEES = "ACTIVE_EMPLOYEES",
  GROSS_FLOOR_AREA = "GROSS_FLOOR_AREA",
  ANNUAL_REVENUE = "ANNUAL_REVENUE",
  ECONOMIC_INTENSITY = "ECONOMIC_INTENSITY",
  PRODUCED_UNITS = "PRODUCED_UNITS",
  TARGET_NO_OF_UNITS = "TARGET_NO_OF_UNITS",
}

export enum ASSET_DROPDOWN_TARGET_NAME {
  DEPARTMENT = "Department",
  CATEGORY = "Category",
  CURRENCY = "currency",
  UOMS = "uoms",
  MAP_ASSET = "mapAssetTo",
  EMISSION_FACTORS_HIERARCHY = "emissionFactorsHierarchy",
  SCOPE_CATOGRIES = "scopeCategories",
  EMISSION_FACTOR_SOURCES = "emissionFactorSources",
  METHODS = "methods",
  EMISSION_SOURCE = "emissionSource",
  ACTIVITY_DATA = "activityData",
}

export enum MAP_ASSET_TO {
  CUSTOM_EMISSION_SOURCE = "Custom emission source",
}

export enum MODE {
  SELECTED = "Selected",
  PLAIN = "Plain",
}

export enum AUTH_MODE {
  SIGNIN = "Signin",
  EMAIL_VERIFY = "EmailVerify",
  SUPPLIER = "Supplier",
  EXTERNAL_VERIFIER = "ExternalVerifier",
}

export enum UPLOAD_TYPE {
  MANUAL = "manual",
  BULKUPLOAD = "bulkupload",
}

export enum FILE_STATUS {
  YET_TO_START = "YetToStart",
}

export enum BUSINESS_UNIT_TARGET_TYPE {
  NAME = "name",
  INCHARGE = "incharge",
  TYPE = "type",
  INDUSTRY_TYPE = "industryType",
  FACILITY_BOUNDARY = "facilityBoundary",
}

export enum DIAL_CODE {
  INDIA = "+91",
  SINGAPORE = "+65",
}
export enum EMISSION_ATTACHMENTS_TYPE {
  FORM_DATA = "formData",
  SOURCE_DATA = "sourceData",
  EMISSION_DATA = "emissionData",
  EMISSION_LOG_DATA = "emissionLogData",
}
export enum EMPLOYEE_DATA_TYPE {
  NAME = "name",
  EMAIL = "email",
  ROLENAME = "roleName",
  DEPARTMENT = "department",
  EMPLOYEECODE = "employeeCode",
  DESIGNATION = "designation",
  MOBILE = "mobile",
  DIALCODE = "dialCode",
  COMPANY_ID = "companyId",
  BUSINESSUNIT_IDs = "businessUnitIds",
  DEFAULT_UNIT = "defaultUnit",
  ADDRESS = "address",
}

export enum APPROVAL_ACTION_TYPE {
  CANCEL = "cancel",
  UPDATE = "update",
}

export enum EMISSION_DATA_STATUS_TYPE {
  RFC = "RFC",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

export enum EMPLOYEE_STATUS_TYPE {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum CUSTOM_EMISSION_TYPE {
  UOM = "uom",
  FACTOR_UOM = "factorUom",
  EMISSION_FACTOR = "emissionFactor",
  ACTIVITY_NAME = "activityName",
  FACTOR_GASES = "factorGases",
  GASES = "gases",
  GAS_EMISSION_FACTOR = "gasEmissionFactor",
}

export enum SETTING_PREFERENCE_TYPE {
  YEAR = "year",
  CARBON_FRAMEWORK = "carbon framework",
  MANAGEMENT_REPORTS = "management reports",
}
